import {
  MYACCOUNT_REQUESTING,
  MYACCOUNT_REQUEST_SUCCESS,
  MYACCOUNT_REQUEST_ERROR,
  MYACCOUNT_POST_REQUESTING,
  MYACCOUNT_POST_SUCCESS,
  MYACCOUNT_POST_ERROR,
} from './constants'

export const myaccountRequest = function myaccountRequest () {  
  return {
    type: MYACCOUNT_REQUESTING,
  }
}

export const myaccountRequestSuccess = function myaccountRequestSuccess (profile) {
  return {
    type: MYACCOUNT_REQUEST_SUCCESS,
    profile,
  }
}

export const myaccountRequestError = function myaccountRequestError (error) {
  return {
    type: MYACCOUNT_REQUEST_ERROR,
    error,
  }
}

export const myaccountPosting = function myaccountPosting (formData) {  
  return {
    type: MYACCOUNT_POST_REQUESTING,
    payload: formData,
  }
}

export const myaccountPostSuccess = function myaccountPostSuccess (data) {
  return {
    type: MYACCOUNT_POST_SUCCESS,
    data,
  }
}

export const myaccountPostError = function myaccountPostError (error) {
  return {
    type: MYACCOUNT_POST_ERROR,
    error,
  }
}


// WEBPACK FOOTER //
// ./src/views/Pages/MyAccount/actions.js